import { defineMessages } from 'react-intl';

// RF01(a)/(b): esta página com/sem sidebar não é um campo de template à
// parte — é este mesmo toggle. `block_parent=true` interrompe a herança dos
// componentes configurados nas páginas acima (ver `Slots.get_data` em
// `je.slots.backend`, que sobe a árvore de ancestrais e para nesse ponto).
// Deixar os slots vazios com o toggle marcado produz "sem sidebar"; adicionar
// componentes aqui produz "com sidebar", mas uma sidebar própria desta
// página, não herdada.
const messages = defineMessages({
  block_parent: {
    id: 'block_parent',
    defaultMessage: 'Bloquear herança da página superior',
  },
  block_parent_description: {
    id: 'block_parent_description',
    defaultMessage: 'Quando marcado, esta página — e as páginas abaixo dela — param de herdar os componentes de barra lateral configurados nas páginas superiores. Deixe os componentes abaixo vazios para uma página sem barra lateral, ou adicione os seus para uma barra lateral própria, independente da hierarquia.',
  },
  hide_all_inherited: {
    id: 'hide_all_inherited',
    defaultMessage: 'Ocultar todos os componentes herdados',
  },
  hide_all_inherited_description: {
    id: 'hide_all_inherited_description',
    defaultMessage: 'Oculta de uma vez, apenas nesta página, todos os componentes que vêm das páginas superiores — sem precisar ocultar um a um. Diferente da opção acima, a herança continua ativa: desmarque para trazer todos de volta, ou reexiba um componente específico pelo seu botão de olho.',
  },
});

const SlotsSchema = ({ props, intl }) => ({
  title: `Edit slot: {props.slotId}`,
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['block_parent', 'hide_all_inherited'],
    },
  ],
  required: [],
  properties: {
    block_parent: {
      id: 'block_parent',
      type: 'boolean',
      title: intl.formatMessage(messages.block_parent),
      description: intl.formatMessage(messages.block_parent_description),
    },
    hide_all_inherited: {
      id: 'hide_all_inherited',
      type: 'boolean',
      title: intl.formatMessage(messages.hide_all_inherited),
      description: intl.formatMessage(messages.hide_all_inherited_description),
    },
  },
});

export default SlotsSchema;
